import "./App.css";

import MainSection from "./modules/MainSection";
import NavTop from "./components/NavTop";
import { Analytics } from "@vercel/analytics/react";
function App() {
  return (
    <div className="bg-bgLight  dark:bg-bgDark min-h-screen ">
      <Analytics />

      <NavTop />
      <MainSection />
    </div>
  );
}

export default App;
